<template>
  <l-rows>
    <back-office-form
      :inputs="inputs"
      mode="create"
      :modes="modes"
      @submit="createSignificantEvent"
    />
  </l-rows>
</template>

<script>
  import BackOfficeForm from '@/components/BackOfficeForm'
  import { LRows, MInputDateTime } from 'codefabrik-gui-vue'
  import { reportingService } from '@/services'
  import { useCreateSignificantEvent } from '@/views/reporting/reportingHooks'
  export default {
    name: 'SignificantEventCreate',
    components: { BackOfficeForm, LRows },
    computed: {
      now () {
        return new Date().toISOString()
      },
      inputs () {
        return [
          {
            name: 'description',
            properties: {
              label: this.$t('common.description')
            },
            validators: 'required'
          },
          {
            name: 'happenedAt',
            is: MInputDateTime,
            properties: {
              label: this.$t('common.happenedAt')
            },
            default: this.now,
            validators: 'required'
          }
        ]
      },
      modes () {
        return {
          create: {
            title: 'reporting.createSignificantEvent',
            subtitles: ['']
          },
        }
      }
    },
    mixins: [useCreateSignificantEvent()]
  }
</script>

<style scoped>

</style>
